"use client"
export default function Footer() {
  return (
    <footer className="w-full bg-white shadow-md px-2 py-2 flex justify-center items-center shadow"  style={{ marginLeft:"5px",borderTopLeftRadius:"10px" }}>
      <p className="text-gray-600 text-sm text-center">
        © {new Date().getFullYear()} ACS eBooks. All rights reserved.
      </p>
    </footer>
  )
}
